module.exports = __webpack_public_path__ + "img/ComingSoon4.5a724bb8.png";